import { useState } from "react";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { FormControl } from "baseui/form-control";
import { ButtonGroup } from "baseui/button-group";
import { Button } from "baseui/button";
import { useUpdateUsersAppRolesMutation } from "../../../services/users/userApi";
import { useReportMutationState } from "../../../hooks/useReportMutationState";
import { FormattedMessage } from "react-intl";

export type TUserRole = {
  id: string;
  name: string;
};

const userRoles: TUserRole[] = [
  { id: "UserRead", name: "User Read" },
  { id: "UserWrite", name: "User Write" },
  { id: "ApplicationAdmin", name: "Application Admin" },
  { id: "SubscriptionAdmin", name: "Subscription Admin" },
];
export const getRolesAsStrings = (selected: number[]) => {
  const roles: string[] = [];
  selected?.map((value: number) => roles.push(userRoles[value].id));
  return roles;
};

function UpdateRolesDialog({ userId, isOpen, setIsOpen }) {
  const [update, updateResult] = useUpdateUsersAppRolesMutation();
  const [selected, setSelected] = useState([0]);
  useReportMutationState(updateResult, () => setIsOpen(false));

  function close() {
    setIsOpen(false);
  }

  async function addRg() {
    const roles = getRolesAsStrings(selected);
    await update({ userId: userId, roleNames: roles });
  }

  return (
    <>
      <Modal onClose={close} isOpen={isOpen}>
        <ModalHeader>Update user access roles</ModalHeader>
        <ModalBody>
          <UpdateRolesFormControl selected={selected} setSelected={setSelected} />
        </ModalBody>
        <ModalFooter>
          <ModalButton kind="tertiary" onClick={close}>
            Cancel
          </ModalButton>
          <ModalButton isLoading={updateResult.isLoading} onClick={addRg}>
            Okay
          </ModalButton>
        </ModalFooter>
      </Modal>
    </>
  );
}

type UpdateRolesFormControlProps = {
  selected: number[];
  setSelected: any;
};

export function UpdateRolesFormControl(props: UpdateRolesFormControlProps) {
  const { selected, setSelected } = props;
  return (
    <FormControl
      label={<FormattedMessage id="selectRoleTemplates" defaultMessage="Select user role template(s)" />}
      caption={() => (
        <>
          <FormattedMessage
            id="selectRoleTemplates.caption1"
            defaultMessage="Select one or more role templates you want to assign to the user"
          />

          <br />
          <FormattedMessage
            id="selectRoleTemplates.caption2"
            defaultMessage="no selection means the user will have no access right"
          />
        </>
      )}>
      <ButtonGroup
        selected={selected}
        onClick={(_event, index) => {
          if (!selected.includes(index)) {
            setSelected([...selected, index]);
          } else {
            setSelected(selected.filter((value) => value !== index));
          }
        }}
        mode="checkbox"
        overrides={{
          Root: {
            style: {
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "10px",
            },
          },
        }}>
        {userRoles.map((value) => (
          <Button key={value.name}>{value.name}</Button>
        ))}
      </ButtonGroup>
    </FormControl>
  );
}

export default UpdateRolesDialog;
